import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaUsers, FaBlog, FaEnvelope, FaUserCircle } from "react-icons/fa";

export default function AdminHeader({ setActiveSection }) {
  return (
    <div
      className="d-flex flex-column flex-shrink-0 p-3 bg-white border-end vh-100"
      style={{ width: "260px" }}
    >
      {/* Logo */}
      <a
        href="/"
        className="d-flex align-items-center justify-content-center mb-4"
        style={{ height: "100px" }} // mantiene el header compacto
      >
        <img
          src="/assets/Logo.png"
          alt="Inerva Psicología"
          style={{
            height: "260px", // altura del logo
            width: "auto",
            objectFit: "contain",
          }}
        />
      </a>

      {/* Navegación */}
      <ul className="nav nav-pills flex-column mb-auto">
        <li className="nav-item mb-2">
          <button
            className="btn btn-outline-success w-100 d-flex align-items-center justify-content-start gap-2"
            onClick={() => setActiveSection("accounts")}
          >
            <FaUsers /> Cuentas
          </button>
        </li>
        <li className="nav-item mb-2">
          <button
            className="btn btn-outline-success w-100 d-flex align-items-center justify-content-start gap-2"
            onClick={() => setActiveSection("blog")}
          >
            <FaBlog /> Blog
          </button>
        </li>
        <li className="nav-item mb-2">
          <button
            className="btn btn-outline-success w-100 d-flex align-items-center justify-content-start gap-2"
            onClick={() => setActiveSection("messages")}
          >
            <FaEnvelope /> Mensajes
          </button>
        </li>
        <li className="nav-item">
          <button
            className="btn btn-outline-success w-100 d-flex align-items-center justify-content-start gap-2"
            onClick={() => setActiveSection("account")}
          >
            <FaUserCircle /> Cuenta
          </button>
        </li>
      </ul>

      <hr />

      {/* Footer del sidebar */}
      <div className="mt-auto text-center">
        <small className="text-muted">&copy; {new Date().getFullYear()} Inerva Psicología</small>
      </div>
    </div>
  );
}
